var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Presence Report","fields":_vm.fields,"response":_vm.data,"filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }